import React, { createContext, useState, useEffect, useContext } from 'react';

const CodeContext = createContext();
// TODO: refactorizar y juntar esto con el context de company, para obtener el id
export function useCode() {
  return useContext(CodeContext);
}

export const CodeProvider = ({ children }) => {
  const [code, setCode] = useState('');

  useEffect(() => {
    // Obtener el código almacenado en localStorage al cargar la página
    const storedCode = localStorage.getItem('code');
    if (storedCode) {
      setCode(storedCode);
    }
  }, []);

  const updateCode = (newCode) => {
    setCode(newCode);
  };

  useEffect(() => {
    // Guardar el código en localStorage al cambiarlo
    localStorage.setItem('code', code);
  }, [code]);

  return (
    <CodeContext.Provider value={{ code, updateCode }}>
      {children}
    </CodeContext.Provider>
  );
};
